<template>
  <modal>
    <div>
      <slot name="header">
        <div class="header">
          <i class="material-icons clickable back" 
            @click="$emit('back')"
            v-if="displayBack">arrow_back</i>
          <h1 style="text-align: center">{{title}}</h1>
          <i class="material-icons clickable close" @click="$emit('close')" >close</i>
        </div>
      </slot>
      <form @submit.prevent="$emit('submit')">
        <div class="form-body">
          <slot></slot>
        </div>
        <button type="submit" class="footer" :disabled="disabled">
          <h1>{{btn}}</h1>
        </button>
      </form>
    </div>
  </modal>
</template>

<script>
import modal from "./index";

export default {
  components: { modal },
  props: ["btn", "title", "displayBack", "disabled"]
};
</script>

<style lang="less" scoped>
@import "../../styles/colors";
@import "../../styles/fonts";

.default-modal {
  width: 500px;
}

.top-bottom {
  padding: .3em 0px;
}

form {
  padding-top: 30px;
  padding-bottom: 30px;
}
.header {
  background-color: @primaryColor;
  font-family: @header;
  color: white;
  margin: 0px auto;
  width: 100%;
  position: absolute;
  .top-bottom;
  top: 0px;
}

.footer {
  background-color: @primaryColor;
  font-family: @header;
  color: white;
  margin: 0px auto;
  width: 100%;
  position: absolute;
  .top-bottom;
  bottom: 0px;
}

.form-body {
  background-color: darkgray;
  color: white;
  padding: 1em;
  max-height: 70vh;
  overflow-y: auto;
  padding-top: 30px;
  padding-bottom: 30px;
  input {
    color: black;
  }

  textarea {
    background-color: white;
    color: black;
    width: 100%;
  }
}

.close {
  position: absolute;
  top: 10px;
  right: 5px;
  color: white;
}

.back {
  position: absolute;
  top: 10px;
  left: 8px;
}

</style>
